import { Link } from "react-router-dom";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import Icon from "../Icon";
import { guidesBaseUrl } from "../../config/urls";

const GuideListMenu = () => {
  const t = useBjelinTranslations();

  return (
    <div>
      <h3>
        <Link to={guidesBaseUrl}>
          <span className="title black-on-hover">{t("guides.title")}</span>
          <span className="more">
            {t("more")}{" "}
            <Icon name="chevron-right" type="fal" className="ms-1" />
          </span>
        </Link>
      </h3>
    </div>
  );
};

export default GuideListMenu;
